var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-row"},[_c('v-btn',{staticClass:"std-btn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('fa',{attrs:{"icon":['fal', 'arrow-alt-left']}}),_c('span',{directives:[{name:"t",rawName:"v-t",value:('back'),expression:"'back'"}],staticClass:"label"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }